(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoDetailController', OrganoDetailController);

    OrganoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Organo', 'OrganoRelevante'];

    function OrganoDetailController($scope, $rootScope, $stateParams, previousState, entity, Organo, OrganoRelevante) {
        var vm = this;

        vm.organo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:organoUpdate', function(event, result) {
            vm.organo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
